// extracted by mini-css-extract-plugin
export default {"content":"CardOverdraftDetails_content__d8ljK","logo":"CardOverdraftDetails_logo__Uri1h","details":"CardOverdraftDetails_details__2L+5v"};